import i18n from "../../locales";
import SocketIOHelper from "../../helpers/SocketIOHelper";
import {fetchCallParkings} from "../../api/callParkingApi";

export default {
    namespaced: true,
    state: {
        callParkings: []
    },
    getters: {
        callParkings: (state) => {
            return state.callParkings
        }
    },
    actions: {
        getCallParkings: (context) => {
            return new Promise((resolve, reject) => {
                fetchCallParkings()
                    .then(response => {
                        context.commit('setCallParkings', response.data)
                        resolve()
                    })
                    .catch(() => reject())
            })
        },
        removeSlot: (context, {callParkingNumber, slotNumber}) => {
            context.commit("removeSlot", {callParkingNumber, slotNumber})
        },
        addSlot: (context, {callParkingNumber, newSlot}) => {
            context.commit("addSlot", {callParkingNumber, newSlot})
        },
    },
    mutations: {
        setCallParkings: (state, callParkings) => {
            state.callParkings = callParkings
        },
        removeSlot: (state, {callParkingNumber, slotNumber}) => {
            const callParking = state.callParkings.find((callParking) => callParking.number === callParkingNumber)
            if (callParking) {
                callParking.slots = callParking.slots.filter((slot) => slot.number !== slotNumber)
            }
        },
        addSlot: (state, {callParkingNumber, newSlot}) => {
            let callParking = state.callParkings.find((callParking) => callParking.number === callParkingNumber)

            if (callParking) {
                let slotExists = callParking.slots.find((slot) => slot.number === newSlot.number)
                if (slotExists) {
                    callParking.slots = callParking.slots.filter((slot) => slot.number !== slotExists.number)
                }

                callParking.slots.push(newSlot)
                callParking.slots.sort((a, b) => a.number - b.number)
            }
        }
    }
}